import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoSimple = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 38,
	height: 52,
	viewBox: "0 0 38 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.16 27.6301H22.22C28.8 27.6301 34.16 22.2701 34.16 15.6901C34.16 9.11011 28.8 3.75011 22.22 3.75011H15.81C14.35 3.75011 13.16 4.94011 13.16 6.40011V27.6301V27.6301ZM10.27 44.9001V30.5201H5.54001C4.08001 30.5201 2.89001 31.7101 2.89001 33.1701V44.9001C2.89001 46.9401 4.55001 48.6001 6.59001 48.6001C8.63001 48.6001 10.29 46.9401 10.29 44.9001M6.59001 51.4901C2.96001 51.4901 0.0100098 48.5401 0.0100098 44.9001V33.1701C0.0100098 30.1101 2.50001 27.6301 5.55001 27.6301H10.28V6.40011C10.27 3.35011 12.76 0.860107 15.81 0.860107H22.22C30.4 0.860107 37.05 7.51011 37.05 15.6901C37.05 23.8701 30.42 30.5201 22.22 30.5201H13.16V44.9001C13.16 48.5301 10.22 51.4901 6.58001 51.4901",
		fill: "currentColor"
	})
});
export default SvgLogoSimple;
